import getNotesEditorViewState from '../selectors/getNotesEditorViewState';
import onForwardeesChanged from '../actions/onForwardeesChanged';
import { mutator } from 'satcheljs';

/**
 * Updates the list of forwardees for an event
 */

export default mutator(onForwardeesChanged, ({ id, forwardees }) => {
    const store = getNotesEditorViewState(id);
    store.forwardees = forwardees;
});
